import { AxiosInstance } from 'axios';
import { AIAvatarsDto, AIAvatarsModel, mapAIAvatarsDtoToModel } from 'api/dto/AIAvatar.dto';
import { CustomAvatarDto } from 'api/dto/new/Perspectives/CustomAvatar.dto';

export class AIAvatarServiceApi {
  constructor(private client: AxiosInstance) {}

  get({ avatarId }: { avatarId: string }): Promise<AIAvatarsModel> {
    return this.client
      .get<AIAvatarsDto>(`/api/v1/avatar/${avatarId}`)
      .then((response) => mapAIAvatarsDtoToModel(response.data));
  }

  getCustomAvatars({ clientId }: { clientId: string }): Promise<CustomAvatarDto[]> {
    return this.client
      .get<CustomAvatarDto[]>(`/api/v1/client/${clientId}/custom-avatars`)
      .then((response) => response.data);
  }
}
